// extracted by mini-css-extract-plugin
export default {"LoadError":"bfq_a bic_qs bic_a bic_w bic_j bic_q","LoadError__icon":"bfq_b bic_vl bic_fm bic_sw","LoadError__message":"bfq_c bic_fm bic_tr"};